const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st, chunkSize) => st.match(new RegExp(`.{${chunkSize}}`, "g"))

const convertHexUnitTo256 = (hexStr) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a, alpha) => {
    if (typeof a !== "undefined") {return a / 255}
    if ((typeof alpha != "number") || alpha <0 || alpha >1){
        return 1
    }
    return alpha
}

const hexToRbga = (color, alpha) => {
    const chunkSize = Math.floor((color.length - 1) / 3)
    const hexArr = getChunksFromString(color.slice(1), chunkSize)
    const [r, g, b, a] = hexArr.map(convertHexUnitTo256)
    // return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`         // if need alfa
    return `rgba(${r}, ${g}, ${b}, .11)`
}

const rgbToRbga = (color) => {
    let newCol = color.replace(/rgb/i, "rgba");
    newCol = newCol.replace(/\)/i,',0.75)');
    return newCol
}

export const colorConvert = (color, alpha) => {
    if (isValidHex(color)) {
        return hexToRbga(color, 0.11)
    } else if (color.indexOf('rgb') === 0 && color.indexOf('rgba') === -1) {
        return rgbToRbga(color)
    } else {
        return color
    }
}